import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationProblemType as SchemaIntegrationProblemType } from '../schemas/IntegrationProblemType';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 * @summary Запустить импорт отзывов для указанной системы
 */
export const StartFeedbacksSyncContentType = '' as const;
export type StartFeedbacksSyncRequest = void;
export type StartFeedbacksSyncResponses = LinkCommonErrorResponses & {
    /**
     * @description Feedbacks sync started successfully
     */
    '200': {};
    /**
     * @description Invalid input or validation error
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaIntegrationProblemType;
        };
    };
};
export type StartFeedbacksSyncResponseSuccess = undefined;
export type StartFeedbacksSyncSearchParams = undefined;
export type StartFeedbacksSyncPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const StartFeedbacksSyncUrl = '/integrations/feedbacks/{integration_type}/start' as const;
export const StartFeedbacksSyncMethod = 'POST' as const;
export const getStartFeedbacksSyncUrl = (params: StartFeedbacksSyncPathParameters) =>
    StartFeedbacksSyncUrl.replace(/\{(\w+)\}/g, (_match, param: keyof StartFeedbacksSyncPathParameters) =>
        String(params[param])
    );
